import {
  FETCH_NOTIFICATIONS,
  ADD_SYSTEM_NOTIFACTION,
  ADD_SYSTEM_NOTIFICATION_LIST,
  SYNCHRONIZATION_STARTED,
  SEND_SYSTEM_NOTIFICATION_REQUESTED,
  SEND_SYSTEM_NOTIFICATION_SUCCEEDED,
  SEND_SYSTEM_NOTIFICATION_FAILED,
} from './actionTypes';

export function fetchSystemNotificationsAction() {
  return {
    type: FETCH_NOTIFICATIONS,
  };
}

export function addSystemNotificationList(list) {
  return {
    type: ADD_SYSTEM_NOTIFICATION_LIST,
    payload: {
      notifications: list,
    },
  };
}

export function addSystemNotification(notification) {
  return {
    type: ADD_SYSTEM_NOTIFACTION,
    payload: {
      notification,
    },
  };
}

export function synchronizationStarted() {
  return {
    type: SYNCHRONIZATION_STARTED,
  };
}

export function sendSystemNotificationRequested(receiversIdList, text) {
  return {
    type: SEND_SYSTEM_NOTIFICATION_REQUESTED,
    payload: {
      receiversIdList,
      text,
    },
  };
}

export function sendSystemNotificationSucceeded() {
  return {
    type: SEND_SYSTEM_NOTIFICATION_SUCCEEDED,
  };
}

export function sendSystemNotificationFailed() {
  return {
    type: SEND_SYSTEM_NOTIFICATION_FAILED,
  };
}



// WEBPACK FOOTER //
// ./src/services/systemNotifications/actions.js